import React, { Component } from 'react'
import "./filtro.scss"
import 'font-awesome/css/font-awesome.min.css';
import { Link } from "react-router-dom";
import $ from 'jquery';
import MediaQuery from 'react-responsive';
import QuoterModal from '../quoter/quoter';
// import sr from '../scrollreveal/scrollreveal'
import 'lightgallery/dist/css/lightgallery.css';
import 'lightgallery/dist/js/lightgallery';
import 'lightgallery/dist/js/lightgallery-all';
import Data from '../data/data'
import Calculator from '../calculadora/calculator';
import { SperantService } from '../common/Http/SperantService'
import { projects } from '../../data/projects';

export default class Filtro extends Component {
    constructor(props){
        super(props)
        this.closeQuoter = this.closeQuoter.bind(this)
        this.sperantService = new SperantService()
    }
    state = {
        cards: [],
        showFilter:true,
        visible: false
    }
    toogleFilter(){
        this.setState({
            showFilter:!this.state.showFilter
        })
    }
    componentDidMount(){

        let timing = setInterval(() => {
            if(window.location.hash == "#tipologias"){
                $('html, body').animate({
                    scrollTop: $("#tipologias").offset().top - 100
                }, 700);
            }
            clearInterval(timing)
        }, 700);
        //  de los dormitorios
        // let modal = setInterval(() => {
        //     $('.content-img').lightGallery(configModal);
        //     clearInterval(modal)
        // }, 1000);
      

        const {card, page} = this.props
        this.sperantService.projects(projects.get(page).sperant_id)
            .then(({data: {project}})=>{
                const cards = card?.cards.map(c => {
                    const type = project.types.find(t => t.id === c.id)
                    if(type){
                        c.min_price = type.min_price
                        c.units_available = type.units_available
                    }
                    return c
                })
                this.setState({cards: cards})
            })

        let dormitorios =  [$("#dorm-1"),$("#dorm-2"),$("#dorm-3")];
        let side =  [$("#exterior"),$("#interior")];
        side.forEach((items)=>{
            items.click((e)=>{
                showSide(e)
            })
        })
        dormitorios.forEach((items)=>{
            items.click((e)=>{
                showDorms(e)
            })
        })

        function showSide(e){
            $(".card").addClass("none")
            $(".card").removeClass("active")
            $(".btn-flat").removeClass("active")
            $("."+e.target.id).removeClass("none")
            $("."+e.target.id).addClass("active")
        }
        function showDorms(e){
            let cantidad = [...document.querySelectorAll(".dormitorios .active")]
                if($("#"+e.target.id)[0].classList[1]=="active"){
                    $("#"+e.target.id).removeClass("active")
                    $("."+e.target.id).removeClass("active")
                    cantidad.length > 1 ? $("."+e.target.id).addClass("none") : todos();
                }else{
                    $("#"+e.target.id).addClass("active");
                    $("."+e.target.id).addClass("active")
                    $(".card").addClass("none");
                    $(".active").removeClass("none");
                    $("#btn-4").removeClass("active")
                    $(".btn-flat").removeClass("active")
                    let none = document.querySelectorAll(".result .none").length
                    let result = document.querySelectorAll(".result .card").length

                    if(result == none){
                        $(".mensaje").removeClass("inactivo")
                        
                    }else if(result >= none){
                        $(".mensaje").addClass("inactivo")
                    }
                }
            }


            function todos(){
                $(".mensaje").addClass("inactivo")
                $(".card").removeClass("none")
                $('#btn-4').addClass("active")
                $('#todos').addClass("active")
            }
            $("#todos").click(function(){
                updateAll()
                this.classList.add("active")
            })
            function updateAll(){
                $(".card").removeClass("none")
                $(".card").removeClass("active")
                $(".btn-num").removeClass("active")
                $(".mensaje").addClass("inactivo")
                $(".btn-flat").removeClass("active")
                $(".btn-flat").attr("data-active","false")
                
                $(".todos").addClass("active")
                $("#btn-4").addClass("active")
            }

            $("#btn-4").click(function(){
                updateAll();
            });

//  de los polygonos 
        let array = [$("#poly-1"),$("#poly-2"),$("#poly-3"),$("#poly-4"),$("#poly-5"),$("#poly-6"),$("#poly-7")]
        array.forEach((items)=>{
            items.click((e)=>{
                fill(e)
            })
        })
        $(".flats .flat-1").click(function(e){

            
            
        })
        if(document.querySelector(".unity")){
            $(".plano .title-line .title").text("Vista")
        }
        if(document.querySelector(".unbox")){
            let arrayFlat = [
                    ".flat-s0",
                    ".flat-1",
                    ".flat-2",
                    ".flat-3",
                    ".flat-4",
                    ".flat-5",
                    ".flat-6",
                    ".flat-7"]
            arrayFlat.forEach((items)=>{
                document.querySelector(items).addEventListener("click",(e)=>{
                    flat(e,items)
                })
            })
            function flat(e,item){
                let actives = document.querySelectorAll(".result .active");
                if(actives.length == 0){
                    $(`.card`).addClass("none")
                    $(`${item}`).removeClass("none")
                    $(`${item}`).addClass("active")
                    $(`.flats ${item}`).attr("data-active","true")
                    $(".flat-all").removeClass("active");
                    $("#btn-4").removeClass("active")
                }else if(document.querySelector(`.flats ${item}`).dataset.active == "true" && actives.length >= 1){
                    $(item).removeClass("active");
                    $(item).addClass("none");
                    $(item).attr("data-active","false")

                    $(".flat-all").removeClass("active");
                    
                    let btnActives = document.querySelectorAll(".controller .active")
                    btnActives.forEach((e)=>{
                        $(`.${e.id}`).addClass("active");
                        $(`.${e.id}`).removeClass("none");
                    })
                    if(btnActives.length == 0){
                        $(".flat-all").addClass("active");
                        $(".card").removeClass("none");
                    }
                }else if(actives.length >= 1){
                    $(`${item}`).removeClass("none")
                    $(`${item}`).addClass("active")
                    $(`.flats ${item}`).attr("data-active","true")
                    $(".flat-all").removeClass("active");
                }
                document.querySelector(".flat-all").addEventListener("click",function(){
                    $(".card").removeClass("none")
                    $(".card").removeClass("active")
                    $(`.btn-flat`).removeClass("active")
                    $(`.btn-flat`).attr("data-active","false")
                    $(".flat-all").addClass("active")
                    $(".btn-num").removeClass("active")

                })
            }
        }
        function fill(e){
                let cantidad = [...document.querySelectorAll(".plano-svg .active")]
                if(document.querySelector("#"+e.target.id).className.animVal == "active"){
                    $("#"+e.target.id).removeClass("active")
                    $("."+e.target.id).removeClass("active")
                    cantidad.length > 1 ? $("."+e.target.id).addClass("none") :
                    $(".card").removeClass("none")
                }else{
                    $("#"+e.target.id).addClass("active");
                    $("."+e.target.id).addClass("active")
                    $(".card").addClass("none");
                    $(".active").removeClass("none");
                }
        
        }
        $(".reset").click(()=>{
            $(".card").removeClass("none");
            $(".controller .active").removeClass("active");
        })
    }
    showQuoter(type) {
        this.setState({type_id: type.id, visible: true})
    }
    closeQuoter() {
        this.setState({visible: false})
    }
    render() {
        // const plano ='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 161.94 213.54"><defs><style>.cls-1{fill:#dcb94d;}.cls-2{fill:#f7f7f7;}.cls-3{fill:#fff;}</style></defs><title></title><g id="Capa_2" data-name="Capa 2"><g id="Layer_1" data-name="Layer 1"><polygon id="poly-1" class="cls-1" points="1 212.54 1 158.32 6.53 158.32 6.53 125.24 55.02 125.24 55.02 127.09 70.05 127.09 70.05 139.06 69.34 139.06 69.34 212.54 1 212.54"/><path class="cls-2" d="M54,126.24v1.85h15v10h-.71v73.48H2V159.32H7.53V126.24H54m2-2H5.53v33.08H0v56.22H70.34V140.06h.71v-14H56v-1.85Z"/><polygon id="poly-2" class="cls-1" points="79.58 99.98 79.58 66.27 83.98 66.27 83.98 60.84 82.39 60.55 80.29 60.25 80.29 55.84 81.63 48.3 82.38 43.77 85.55 25.66 87.85 12.34 106.27 15.54 160.76 25.02 157.03 44.12 156.13 48.66 155.85 50.27 151.89 50.27 151.89 70.27 151.84 70.68 146.09 99.98 79.58 99.98"/><path class="cls-2" d="M88.66,13.5l17.44,3,53.49,9.31L156,43.93l-.89,4.54-.14.8h-4.12V70.2l0,.33L145.27,99H80.58V67.27H85V60l-2.41-.43-1.28-.19V55.93l1.18-6.66.14-.8.76-4.54,3.17-18.1,1.6-9.31.52-3M87,11.19l-.34,2-.52,3-1.6,9.31L81.4,43.59l-.76,4.55-.14.79-1.18,6.65,0,.18v5.35l1.71.25,1.25.19.73.12v3.6h-4.4V101h68.34l.31-1.62,5.58-28.44v-.1l0-.33,0-.14V51.27h3.8l.29-1.66.14-.8.89-4.49,3.54-18.1.39-2-2-.35-53.49-9.31L89,11.53l-2-.34Z"/><polygon  id="poly-3" class="cls-1" points="67.34 147.14 67.34 137.06 68.05 137.06 68.05 129.09 53.02 129.09 53.02 127.24 6.53 127.24 6.53 94.95 61.58 94.95 61.58 87.69 44.95 87.69 44.95 47.09 67.27 47.09 67.27 48.74 80.66 48.74 83.49 49.2 82.29 56.02 82.29 58.53 85.98 59.15 85.98 68.27 81.58 68.27 81.58 97.98 85.98 97.98 85.98 116.61 81.58 116.61 81.58 147.14 67.34 147.14"/><path class="cls-2" d="M66.26,48.09v1.65H80.58l1.75.29-1,5.9v3.45L85,60v7.27h-4.4V99H85v16.63h-4.4v30.53H68.34v-8.08h.71v-10H54v-1.85H7.53V96H62.58V86.69H46V48.09H66.26m2-2H44v42.6H60.58V94h-55v34.28H52v1.85h15v6h-.71v12.08H82.58V117.61H87V97h-4.4V69.27H87v-11L85.31,58l-2-.33V56.11l1-5.74.35-2-2-.33-1.75-.28-.16,0H68.26V46.09Z"/><polygon id="poly-4" class="cls-1" points="67.34 212.53 67.34 145.14 79.58 145.14 79.58 114.61 83.98 114.61 83.98 97.98 146.49 97.98 142.99 115.81 137.04 146.33 133.76 163.06 129.21 163.06 129.21 186.22 124.16 186.22 124.16 202.85 119.05 202.85 119.05 212.53 67.34 212.53"/><path class="cls-2" d="M145.27,99,142,115.61l-6,30.53-3.11,15.92h-4.73v23.16h-5.05v16.63h-5.11v9.68H68.34V146.14H80.58V115.61H85V99h60.29m2.43-2H83v16.63h-4.4v30.53H66.34v69.39h53.71v-9.68h5.11V187.22h5.05V164.06h4.37l.32-1.61L138,146.52,144,116l3.26-16.64L147.7,97Z"/><polygon id="poly-5" class="cls-1" points="44.25 87.69 6.39 64.73 16.83 47.57 17.84 45.88 2.04 36.28 16.22 12.98 23.42 1.1 89.82 12.69 85.77 36.12 84.07 45.71 83.65 48.25 83.15 51.17 80.5 50.74 65.26 50.74 65.26 49.09 46.94 49.09 46.94 87.69 44.25 87.69"/><path class="cls-3" d="M23.92,2.21,88.66,13.5,84.79,35.94l-1.7,9.6-.43,2.55-.28,1.65,0,.28-1.75-.28H66.26V48.09H45.94v38.6H44.53L7.76,64.39l9.93-16.3,1.51-2.55L3.42,35.94,17.07,13.5,23.92,2.21M22.92,0l-.71,1.17L15.36,12.46,1.71,34.91l-1,1.7,1.71,1,14.09,8.57-.5.85L6.05,63.35,5,65.06l1.72,1L43.49,88.4l.48.29h4V50.09H64.26v1.65H80.42L82,52l2,.32.33-2,0-.29.28-1.64.43-2.56,1.7-9.58,3.87-22.45.34-2-2-.34L24.27.23,22.92,0Z"/></g></g></svg>'
        
        return (
            <Data.Consumer>
                {
                    context =>{
                        return(
            <div className={"filtro flex-column "+this.props.page} id="tipologias">
                <h2 className="title-main">ELIGE TU <span className='bold'>CASA IDEAL</span></h2>
                <MediaQuery query="(max-width: 700px)">
                <div className='btn-select flex-column'>Elige el número de departamentos : 
                    <div className='dormitorios'>
                        <div className="flex-row">
                            <div className='btn-num' id="dorm-1">{this.props.numero.btn1}</div>
                            <div className='btn-num' id="dorm-2">{this.props.numero.btn2}</div>
                            <div className='btn-num' id="dorm-3">{this.props.numero.btn3}</div>
                            <div className='btn-num active' id="btn-4">Todos</div>
                        </div>
                    </div>
                </div>
                </MediaQuery>
                <div className='content-filter flex-row'>
                    <Calculator page={this.props.page} url={this.props.url}></Calculator>
                    <div className={`controller`}>
                        <div className='plano'>
                            <div className="title-line">
                                <span className="title">Plano</span>
                            </div>
                            <div className="title-line title-filter-unbox">
                                <span className="title">Piso</span>
                            </div>

                            <div className='plano-svg' dangerouslySetInnerHTML={{__html:this.props.card.filtro}}>
                            </div>
                            <div className="flats">
                                <div className="btn-flat flat-s0" data-flat="flat-s0" id="flat-s0">S0</div>
                                <div className="btn-flat flat-1" data-flat="flat-1" id="flat-1">1</div>
                                <div className="btn-flat flat-2" data-flat="flat-2" id="flat-2">2</div>
                                <div className="btn-flat flat-3" data-flat="flat-3" id="flat-3">3</div>
                                <div className="btn-flat flat-4" data-flat="flat-4" id="flat-4">4</div>
                                <div className="btn-flat flat-5" data-flat="flat-5" id="flat-5">5</div>
                                <div className="btn-flat flat-6" data-flat="flat-6" id="flat-6">6</div>
                                <div className="btn-flat flat-7" data-flat="flat-7" id="flat-7">7</div>
                                <div className="btn-flat flat-all active">Todos</div>
                            </div>
                            <div className="side-room">
                                <div className="btn-flat btn-side exterior" data-flat="flat-7" id="exterior">Exterior</div>
                                <div className="btn-flat btn-side interior" data-flat="flat-7" id="interior">Interior</div>
                                <div className="btn-flat btn-side todos active" data-flat="flat-7" id="todos">Todos</div>

                            </div>
                        </div>
                        <div className='dormitorios'>
                            <div className="title-line">
                                <span className="title">Dormitorios</span>
                            </div>
                            <div className="flex-row">
                                <div className='btn-num' id="dorm-1" >{this.props.numero.btn1}</div>
                                <div className='btn-num' id="dorm-2" >{this.props.numero.btn2}</div>
                                <div className='btn-num' id="dorm-3" >{this.props.numero.btn3}</div>
                                <div className='btn-num active' id="btn-4">Todos</div>
                            </div>
                            <div className="flex-row line-2">
                                <div className='btn-num'>{this.props.numero.btn1}</div>
                                <div className='btn-num'>{this.props.numero.btn2}</div>
                                <div className='btn-num'>{this.props.numero.btn3}</div>
                            </div>
                        </div>
                        <div className='area-total'>
                            <div className="title-line">
                                <span className="title">Área total</span>
                            </div>
                            {/* <Recorrido></Recorrido> */}
                            <div className='reset'>Restablecer filtros</div>
                        </div>
                    </div>
                    <div className='result' id="result">
                        <div className="mensaje inactivo">
                                Lo sentimos, ya no nos quedan departamentos con esas características.
                        </div>
                        {
                            this.state.cards.map((element,index)=>{
                               return( 
                               <div key={index-"cards"} className={`card ${element.class} ${"card-"+index}`}>
                                    <div className='flat flex-row'>
                                    <div className="flex-colum header-flat">
                                        <span className="d-block tipo">{element.type}</span>
                                        <span className='d-block dormitorio'>{element.dorms}</span></div>
                                        <img className='img-header' src={element.brand}></img>
                                    </div>
                                    <div className='content-img'>
                                        <img className='' src={element.img}></img>
                                        <div className="lupa" href={element.img}>
                                            <div className="content-icon-lupa" >
                                                <div className="icon-lupa"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='attributes'>
                                        <div className='flex-row row techado'><span>Área techada:</span><span className=''>{element.meters}</span></div>
                                        <div className='flex-row row'><span className="bold">Área total:</span><span className='bold'>{element.metersTotal}</span></div>
                                        <div className='flex-row row area-desde'><span className="bold">Área desde: </span><span className='bold'>{element.metersTotal}</span></div>
                                    </div>
                                    <div className="content-buttons">
                                        <div className='btn-card' onClick={(e)=>context.openCalculator("open", element.id, this.props.page, "card-"+index)}>
                                            <div className="icon-calculate"></div>
                                            <span className="text">Calcular cuota</span>
                                        </div>
                                        <div className="content-button-card">
                                            <div className='btn-separe' id={`btn-${element.id}`} onClick={()=>this.showQuoter(element)}>
                                                <div className="icon-separe"></div>
                                                <span className="text">Consultar</span>
                                            </div>
                                            <div className="separate"></div>

                                            <div className='btn-consult' onClick={()=>this.showQuoter(element)}>
                                                <div className="icon-consult"></div>
                                                <span className="text">Cotizador</span>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                )
                            })
                        }
                        <QuoterModal
                        visible={this.state.visible}
                        actionModalCancel={this.closeQuoter}
                        type_id={this.state.type_id}
                        page={this.props.page}
                        template_id={this.props.card.template_id}/>
                    </div>
                </div>
            </div>
                )}}
            </Data.Consumer>
        )
    }
}
